











































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'


    class PageFlowRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        statisticalType: number;
        //channel: number;
        constructor() {
            super();
            this.statisticalType = 1;
            //this.channel = 2;
        }
    }

    @Component({
        name: "fontamountFlowStatistical",
    })
    export default class flows extends AbpBase {
        channel = Enums.UserAmountChannel;
        statisticalType = Enums.StatisticalType;
        pagerequest: PageFlowRequest = new PageFlowRequest();
        packedTime: Date[] = [new Date(), new Date()];
        get list() {
            return this.$store.state.fontflowAmountStatistical.list;
        };
        get loading() {
            return this.$store.state.fontflowAmountStatistical.loading;
        };
        //pageChange(page: number) {
        //    this.$store.commit('packstatistical/setCurrentPage', page);
        //    this.getpage();
        //};
        //pagesizeChange(pagesize: number) {
        //    this.$store.commit('packstatistical/setPageSize', pagesize);
        //    this.getpage();
        //};

        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.packedTime.length > 0) {
                this.pagerequest.beginTime = this.packedTime[0];
            }
            if (this.packedTime.length > 1) {
                this.pagerequest.endTime = this.packedTime[1];
            }

            await this.$store.dispatch({
                type: 'fontflowAmountStatistical/getAll',
                data: this.pagerequest
            })
        }
        async searchPage() {
            this.$store.state.fontflowAmountStatistical.currentPage = 1;
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.fontflowAmountStatistical.pageSize;
        }
        get totalCount() {
            return this.$store.state.fontflowAmountStatistical.totalCount;
        }
        get currentPage() {
            return this.$store.state.fontflowAmountStatistical.currentPage;
        }
        columns = [
            {
                title: '支付宝充值',
                sortable: true,
                key: 'alipay',
                width: 211,

            },
            {
                title: '平台消费',
                sortable: true,
                key: 'platformConsumption',
                width: 211,

            },
            {
                title: '平台退款',
                sortable: true,
                key: 'platformRefund',
                width: 211,

            },
            {
                title: '退货消费',
                sortable: true,
                key: 'returnCost',
                width: 211,

            },
            {
                title: '打包消费',
                sortable: true,
                key: 'packedCost',
                width: 211,

            },
            {
                title: '打包退款',
                sortable: true,
                key: 'packedRefund',
                width: 211,

            },
            {
                title: '运费消费',
                sortable: true,
                key: 'freightCost',
                width: 211,
            },
            {
                title: '运费退款',
                sortable: true,
                key: 'freightRefund',
                width: 211,
            },
            {
                title: '日期',
                sortable: true,
                key: 'createTime',
                width: 300,
                render: (h: any, params: any) => {
                    return h('span', params.row.createTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            }
        ]
        async created() {
            this.getpage();
        }
    }
